<template>
  <div>
    <div class="extra-container">
      <input
      :placeholder="keyLabel"
      class="extra-value"
      type="text"
      v-model="extraKey">
      <input
      :placeholder="valueLabel"
      class="extra-value"
      type="text"
      v-model.number="extraValue">
      <button
      class="button"
      @click="this.addOne">
        <span v-if="addLabel">{{addLabel}}</span>
        <i v-else class="fa fa-plus-circle"></i>
      </button>
    </div>
    <p v-if="this.errorEmpty" class="extra-error">{{emptyLabel}}</p>
    <div
    v-for="(value, index) in this.values"
    :key="index"
    class="extra-container">
      <span class="extra-value"><b>{{index}}:</b></span>
      <span class="extra-value">{{value}}</span>
      <button class="button" @click="remove(index)">
        <span v-if="removeLabel">{{removeLabel}}</span>
        <i v-else class="fa fa-minus-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['articleExtra', 'keyLabel', 'valueLabel', 'addLabel', 'removeLabel', 'emptyLabel'],
  data: function() {
    return {
      extraKey: null,
      extraValue: null,
      values: this.articleExtra || {},
      errorEmpty: null
    };
  },
  methods: {
    addOne: function() {
      if (this.checkExtra()) {
        this.errorEmpty = null;
        this.values[this.extraKey] = this.extraValue;
      } else {
        this.errorEmpty = this.emptyLabel;
      }
      this.$emit("update:articleExtra", this.values);
      this.resetExtra();
    },
    remove: function(index) {
      this.$delete(this.values, index);
      this.$emit("update:articleExtra", this.values);
    },
    resetExtra: function() {
      this.extraKey = null;
      this.extraValue = null;
    },
    checkExtra: function() {
      return this.extraKey && this.extraValue;
    }
  }
}
</script>

<style lang="scss" scoped>
.extra-container {
  display: flex;
  flex-direction: row;
}

.extra-value {
  margin: 8px;
  outline: none;
  max-width: 128px;
  font-size: 16px;
}

.extra-error {
  margin-left: 8px;
  margin-bottom: 8px;
  color: $warn_red;
  font-weight: bold;
  font-size: 14px;
}

.button {
  border: none;
  background: none;
  margin-left: 8px;
  padding: 0px;
  font-weight: bold;
  color: black;
  font-size: 16px;

}
</style>
